import curves from "../../../../content/posts/blogs/2024/measuring-performance/curves.jsx";
import * as React from 'react';
export default {
  curves,
  React
};